export { default } from './conditionColorMap';
